import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                   Common barriers to success &amp; remedy advice
              </span></div>
                                            <p className="pbodyfont_modified">In developing strategic
                                                long-term goals, people experience a number of common
                                                barriers. You may even be facing one or two of these right
                                                now! Some are outlined below with a little guidance for
                                                overcoming them.</p>
                                            <table border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left"
                                                        style={{paddingLeft:'10px'}} width="20%">Barrier
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        style={{paddingLeft:'18px'}}>Remedy Advice
                                                    </th>
                                                </tr>

                                                <tr valign="top" bgcolor="#daeac1">
                                                    <td className="darkgreen"><b>The goal is complex and you
                                                        don't know how you will be able to achieve it in
                                                        practice</b></td>

                                                    <td className="list_artc darkgreen">
                                                        <div className="">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Manage
                                                                expectations by giving people sufficient
                                                                time to meet the goal or improve
                                                                performance.</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Provide
                                                                time for practice or learning what is
                                                                expected and required for success.</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Make
                                                                the 'milestones' as specific as possible so
                                                                you can keep on top of them.</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Consider
                                                                the 'pinch points' you might be facing, from
                                                                future events - situations that you know are
                                                                likely to, or will, arise.</p></div>
                                                    </td>

                                                </tr>
                                                <tr className="blank_bg" valign="top">
                                                    <td className=""><b>You are devoid of ideas on how to
                                                        develop the initial concept</b></td>

                                                    <td className="list_artc">
                                                        <div className="">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Take
                                                                a wide-ranging look around at what's going
                                                                on both inside and outside the organisation
                                                                which might affect it, using an
                                                                'environmental scan' or a SWOT analysis.</p>
                                                        </div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Establish
                                                                statements of mission, vision and priority
                                                                actions/issues.</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>You
                                                                may want to refer to the 'How to think about
                                                                problems laterally' tool to help you develop
                                                                the concept.</p></div>

                                                    </td>
                                                </tr>
                                                <tr valign="top" bgcolor="#daeac1">
                                                    <td className="darkgreen"><b>You are struggling to think
                                                        of how your plan fits in with future challenges</b>
                                                    </td>
                                                    <td className="list_artc darkgreen">
                                                        <div className="">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Be
                                                                clear what your overall objective is and how
                                                                this fits in with the bigger picture.</p>
                                                        </div>
                                                        <div className="inner-line ">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Consider
                                                                where the organisation or your department
                                                                might be in the future, e.g. in the next 6
                                                                months, next year, next
                                                                couple of years, etc.</p></div>
                                                        <div className="inner-line ">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Be
                                                                clear what the risks are - consider doing a
                                                                simple risk
                                                                analysis.</p></div>

                                                    </td>
                                                </tr>
                                                <tr className="blank_bg" valign="top">
                                                    <td className="brdrrad_bg "><b>You have an idea but are
                                                        not sure who to consult with and at which stage to
                                                        get it accepted</b></td>
                                                    <td className=" list_artc">


                                                        <div className="">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Consider
                                                                who the key stakeholders are in the process.
                                                                Is this your plan or are you implementing
                                                                someone else's vision?</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>Also,
                                                                think about who the end users might be or
                                                                who may be affected by the outputs of the
                                                                strategy or need to be involved
                                                                along the way, for example, your internal or
                                                                external customers.</p></div>
                                                        <div className="inner-line">
                                                            <div className="inner-line-image sept"><img
                                                                src={require('@images/green-circle-small.png')}/>
                                                            </div>
                                                            <p style={{fontFamily: 'ek_muktalight, san-serif !important',fontSize: '12pt'}}>You
                                                                could set up a forum such as a steering
                                                                committee to
                                                                look at the idea or you may want to put
                                                                together a business plan or proposal to
                                                                'sell' the idea or the benefits to others to
                                                                gain their buy-in.</p></div>


                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="circle_title">
                                                <img alt=""
                                                     src={require('@images/greendot.jpg')}/>
                                                V-SPORT SELF-ANALYSIS
                                            </div>
                                            <p>In order for you to consider your approach to developing
                                                strategic long-term goals use the following tool to
                                                highlight your relative strengths and
                                                aspects in need of development in all the V-SPORT
                                                dimensions.</p>

                                            <div className="border_subtitle">Step 1: Complete the
                                                self-analysis questionnaire
                                            </div>
                                            <p>Complete the self-analysis questionnaire using the Red (R),
                                                Amber (A), Green (G) system. Write in the corresponding
                                                letter (R, A or G) using
                                                the key on the next page.</p>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}